import { render, staticRenderFns } from "./SportelloContrattiDaFirmareView.vue?vue&type=template&id=fbd5d304&"
import script from "./SportelloContrattiDaFirmareView.vue?vue&type=script&lang=ts&"
export * from "./SportelloContrattiDaFirmareView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports